import React  from "react";
import {Link} from 'react-router-dom'
// import SimpleSlider from '../reactslick/ReactSlick'
import './Home.css';
// import '../App.css'

const Home=()=>{
  
    return(
        <div className="home-out">
                     {/* <div className="react-slide">
                    <SimpleSlider/>  
                    </div> */}
                <div className="intro">
                   
                 
                    <div className="intro-inside">
                    <h1>Are you planning to start your Journey with Tabla?</h1>
                    <br/>
                   
                    <p>Well, you have arrived at the right place!!</p>
                    </div>
                   
                </div>               
            <div className="bottom">
            <Link className="tabla-link" to="/what">
                     <div className="whats">
               
                     What is Tabla?       
                     </div>                     
            </Link>
                       
            <Link className="tabla-link" to="/play">      
             <div className="whats">
                     How to Play Tabla?                                                            
             </div>
             </Link>   
            </div>
             
        </div>
   
    )
}
export default Home